import { rollStatusCodes } from "@/shared/selectors/RollStatusSelector";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";

type Props = {
	sectionName: string;
	standName: string;
	rollsetLetter: string;
	topRollName: string;
	bottomRollName: string;
	isActualTopRoll?: boolean;
	status: string;
};

export const RollsetCard = ({
	sectionName,
	standName,
	rollsetLetter,
	topRollName,
	bottomRollName,
	isActualTopRoll = false,
	status,
}: Props) => {
	return (
		<Card variant="outlined" sx={{ borderRadius: 2 }}>
			<CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						mb: 1,
					}}
				>
					<Typography variant="body1" fontWeight="bold">
						In Rollset
					</Typography>
					<Chip
						label={
							rollStatusCodes.find((s) => s.Code === status)?.Name || "Unknown"
						}
						sx={{
							bgcolor:
								rollStatusCodes.find((s) => s.Code === status)?.Color ||
								"default",
							color: status === "B" || status === "K" ? "#2E2E2E" : "white",
							height: 20,
							fontSize: "0.75rem",
						}}
						size="small"
					/>
				</Box>

				<Box
					sx={{
						display: "flex",
						justifyContent: "space-around",
						textAlign: "center",
						bgcolor: "grey.100",
						borderRadius: 1,
						py: 0.75,
						mb: 1,
					}}
				>
					<InfoItem value={sectionName} label="Section" />
					<InfoItem value={standName} label="Stand" />
					<InfoItem value={rollsetLetter} label="Letter" />
				</Box>

				<Box
					sx={{
						display: "flex",
						gap: 1,
					}}
				>
					<RollItem
						label="Top Roll"
						value={topRollName}
						isActual={isActualTopRoll}
					/>
					<RollItem
						label="Bottom Roll"
						value={bottomRollName}
						isActual={!isActualTopRoll}
					/>
				</Box>
			</CardContent>
		</Card>
	);
};

type InfoItemProps = {
	value: string;
	label: string;
};

const InfoItem = ({ value, label }: InfoItemProps) => (
	<Box>
		<Typography variant="body1" fontWeight="bold" color="text.primary">
			{value}
		</Typography>
		<Typography
			variant="caption"
			color="text.secondary"
			sx={{ fontSize: "0.7rem" }}
		>
			{label}
		</Typography>
	</Box>
);

type RollItemProps = {
	label: string;
	value: string;
	isActual: boolean;
};

const RollItem = ({ label, value, isActual }: RollItemProps) => (
	<Box
		sx={{
			flex: 1,
			bgcolor: "grey.100",
			border: (theme) =>
				isActual ? `1px dotted ${theme.palette.primary.main}` : "none",
			borderRadius: 1,
			p: 1,
		}}
	>
		<Typography variant="caption" color="text.secondary">
			{label}
		</Typography>
		<Typography variant="body2" fontWeight="bold">
			{value}
		</Typography>
	</Box>
);
